export default "//cloud.imgsmail.ru/cloud.mail.ru/182280/img/build/subscriptions/cancel-autorenew.png";